
import BaseBlock from '@headlines/utils/BaseBlock';
import BaseButton from '@core/components/UI/BaseButton.vue';
import { HeadlineTitle, HeadlineImage, HeadlineAuthor, HeadlineLabels, HeadlineLead, HeadlineIcons } from '../../../fragments';
import ContentFragment from '@core/components/ContentFragment.vue';
import BlockTabs from '../../../BlockTabs.vue';
import HeadlineTitleList from '../../../HeadlineTitleList.vue';
import BlockTypeSettings from '@headlines/types/block/11-20/blockType13';

interface Methods {
  executeScript: (script: string) => void;
}

const defaultSettings = {
  icons: true,
  author: true,
  titleComment: true,
  channel: true,
  category: true,
  initialTab: 1,
  showTabsComments: true,
  lead: true,
  mobileHeadlineListLimit: 5,
  type: 'list',
};

export default BaseBlock<BlockTypeSettings>(defaultSettings).extend<unknown, Methods, unknown, unknown>({
  components: {
    HeadlineTitle,
    HeadlineImage,
    HeadlineAuthor,
    HeadlineLabels,
    HeadlineIcons,
    HeadlineLead,
    BlockTabs,
    HeadlineTitleList,
    BaseButton,
    ContentFragment,
  },
  methods: {
    executeScript(script) {
      eval(script);
    },
  },
});
